export interface User {
  username?: string;
  avatar?: string;
  avatarLarge?: string;
  avatarXLarge?: string;
}

export enum AvatarSize {
  XXSMALL = 'xxsmall',
  XSMALL = 'xsmall',
  SMALL = 'small',
  MENU = 'menu',
  SMALL_MID = 'small-mid',
  MID = 'mid',
  LARGE = 'large',
  XLARGE = 'xlarge',
  XXLARGE = 'xxlarge',
  MAX = 'max',
}

export enum BackgroundColourType {
  BLUE_DARK = 'blue-dark',
  NEUTRAL_LIGHT = 'neutral-light',
  NEUTRAL = 'neutral',
}
